export const WIFI_AIRPORTS = [
  {
    ko: '인천공항 T1 & T2',
    en: 'Incheon Airport T1 & T2',
  },
];

export const WIFI_PORTS = [
  {
    ko: '인천항 & 부산항',
    en: 'Incheon Port & Busan Port',
  },
];

export const TICKET_PLACE = [
  {
    ko: '김포국제공항',
    en: 'Gimpo Airport',
  },
  {
    ko: '그 외',
    en: 'etc',
  },
];

export const WIFI = {
  airport: 'AirportWiFi(Free FAST)',
  port: 'Public WiFi Free',
};
